import pageDirective from "./page-directive";

export {pageDirective};
